import React, {PureComponent} from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Toolbar from '@material-ui/core/Toolbar';
import Expansion from 'components/common/Expansion';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import CollectionCaseComments from 'components/page/CollectionCase/CollectionCaseComments';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import {getCollectionCase, patchCollectionCase} from 'api/debtCollectionMonitor'
import {dateToDate, toDate, toMoney, getCorrect} from 'data/converter';
import styles from './styles.module.sass';
import ExpansionPanelCredit from 'components/page/CollectionCaseEditor/ExpansionPanelCredit/ExpansionPanelCredit';
import ExpansionPanelPenaltyAndLegalCost from 'components/page/CollectionCaseEditor/ExpansionPanelPenaltyAndLegalCost';
import DateField from 'components/common/DateField';
import AttachFiles from 'components/page/CollectionCaseEditor/AttachFiles';
import Spinner from 'components/common/Spinner';
import TextField from 'components/common/TextField';
import NumberField from 'components/common/NumberField';
import Label from 'components/common/Label';

const mapStateToProps = state => ({
  dicts: state.dictionary,
  user: state.user
});

@connect(mapStateToProps)
class CollectionCaseEditor extends PureComponent {
  state = {
    loading: false,
    isChange: false,
    error: '',
    data: {
      //Статус работы по взысканию
      collectionCaseStateId: '',
      //Краткое описание
      creditDealStateId: '',
      //Тип Займа
      finRequestTypeId: '',
      //Сумма Займа
      creditCaseSum: '',
      //Дата Выдачи
      issueDate: '',
      //Сумма К возврату
      totalRefund: '',
      //Текущий срок займа
      countDay: '',
      //Дата Возврата
      returnDate: '',
      //Проценты
      percent: '',
      //Отправка денег
      sendingMoneyTypeId: '',
      //** Частичное возмещение
      //** Штрафы и неустойки
      //Дата следующего просмотра
      nextMonitoringDate: '',
      //--//
      //ЭТП
      etpName: '',
      //ФЗ
      fz: '',
      //Номер закупки
      numberOnEtp: '',
      //** Реестр БГ
      //Дата ППИ
      resultProtocolPublicationDate: '',
      //** Статус заемщика
      //Дата Протокола Отказа
      denialProtocolPublicationDate: '',
      //--//
      //ФИО Поручителя
      guarantorFullName: '',
      //** Договор поручительства
      //Наименование Агента
      agentName: '',
      //ИНН Агента
      agentINN: '',
      //E-mail Агента
      agentEmail: '',
      //Телефон Агента
      agentPhone: '',
      //--//
      //** Наименование заемщика
      //** ИНН заемщика
      //ФИО Основного Контакта Заемщика
      mainBorrowerFullName: '',
      //ФИО из заявки Заемщика
      requestBorrowerFullName: '',
      //E-mail Основного Контакта Заемщика
      mainBorrowerEmail: '',
      //E-mail Из заявки Заемщика
      requestBorrowerEmail: '',
      //Телефон Основного Контакта Заемщика
      mainBorrowerTelephone: '',
      //Телефон из заявки Заемщика
      requestBorrowerTelephone: '',
      //Номер заявки
      finRequestNumber: '',
      //Дата последнего изменения
      lastChangeDate: '',
      //Инвестор физ. лицо
      investorPhysicalPersonExists: '',
      attachFiles: null,
      additionalContacts: null,
      penalty: null,
      legalCosts: null,
    }
  };

  componentDidMount() {
    const {id} = this.props;
    this.setState({loading: true});
    getCollectionCase(id)
      .then(data => {
        this.setState({data: data, loading: false});
      }).catch(e => this.setState({loading: true}));
  }

  tempStateData = null;
  handlerOnChange = (nextDataValue) => {
    let {data} = this.state;
    const tempStateData = this.tempStateData;
    data = {...data, ...tempStateData};
    data = {...data, ...nextDataValue};
    this.tempStateData = data;

    const nextState = {error: '', isChange: true, data};
    this.setState(nextState);
  };

  renderFieldLink = (label, field, alias) => {
    let v = field && this.state.data[field] || '';

    return [
      <Typography
        key='field-label'
        className={cx(styles.panelDetailsCellLabel, styles.panelDetailsCell)}>{label}
      </Typography>,
      <Typography
        key='field-value'
        className={cx(styles.panelDetailsCellValue, styles.panelDetailsCell)}
      >
        {v &&
        <a href={v} target='_blank'>{alias}</a>
        }
      </Typography>
    ];
  };

  renderField = (label, field, format) => {
    let v = field && this.state.data[field];
    if (format) v = format(v);

    return [
      <Typography
        key='field-label'
        className={cx(styles.panelDetailsCellLabel, styles.panelDetailsCell, {[styles.panelDetailsCellTodo]: !field && !!label})}
      >
        {label}
      </Typography>,
      <Typography
        key='field-value'
        className={cx(styles.panelDetailsCellValue, styles.panelDetailsCell, {[styles.panelDetailsCellTodo]: !field && !!label})}
      >
        {v}
      </Typography>
    ];
  };

  renderFieldDateEdit = (label, field, options) => {
    let v = field && this.state.data[field] || '';
    let dateValue = toDate(v);

    const {placeholder, disabled, gteCurrentDate, gteDate, lteDate} = options || {};

    return [
      <Typography
        key='field-label'
        className={cx(styles.panelDetailsCellLabel, styles.panelDetailsCell)}>{label}
      </Typography>,
      <div
        className={cx(styles.panelDetailsCellValue, styles.panelDetailsCell)}
        key='field-value'
      >
        <DateField
          disabled={disabled}
          gteCurrentDate={gteCurrentDate}
          gteDate={gteDate}
          lteDate={lteDate}
          placeholder={placeholder}
          value={dateValue}
          onChange={v => this.handlerOnChange({[field]: v})}
        />
      </div>
    ];
  };

  renderFieldBool = (label, field) => {
    let v = field && this.state.data[field] || '';

    return [
      <Typography
        key='field-label'
        className={cx(styles.panelDetailsCellLabel, styles.panelDetailsCell)}
      >
        {label}
      </Typography>,
      <Typography
        key='field-value'
        className={cx(styles.panelDetailsCellValue, styles.panelDetailsCell)}
      >
        {v ? 'Да' : 'Нет'}
      </Typography>
    ];
  };

  renderFieldDict = (label, field, dict) => {
    if (!dict) return this.renderField(label);

    let v = field && this.state.data[field].toString();
    return [
      <Typography
        key='field-label'
        className={cx(styles.panelDetailsCellLabel, styles.panelDetailsCell)}>{label}
      </Typography>,
      <div
        key='field-value'
        className={cx(styles.panelDetailsCellValue, styles.panelDetailsCell)}
      >
        <Select
          style={{width: '100%'}}
          value={v}
          displayEmpty
          onChange={e => this.handlerOnChange({[field]: e.target.value})}
        >
          {Object.keys(dict).map((key) =>
            <MenuItem key={key} value={key}>{dict[key]}</MenuItem>
          )}
        </Select>
      </div>
    ];
  };

  onSave = () => {
    const {onSave, user: {id: personId}} = this.props;
    patchCollectionCase(this.state.data, personId)
      .then(() => {
        this.setState({isChange: false});
        if (onSave) onSave();
      })
      .catch((error) => {
        if (!error.response || error.response.status === 400) {
          this.setState({error: error.response && error.response.data || ""})
        }
      });
  };

  renderFieldText = (label, field) => {
    let v = field && this.state.data[field] || '';
    return [
      <Typography
        key='field-label'
        className={cx(styles.panelDetailsCellLabel, styles.panelDetailsCell)}>{label}
      </Typography>,
      <div
        className={cx(styles.panelDetailsCellValue, styles.panelDetailsCell)}
        key='field-value'
      >
        <TextField
          value={v}
          onChange={v => this.handlerOnChange({[field]: v})}
        />
      </div>
    ];
  };

  renderFieldNumber = (label, field, options) => {
    let v = '';

    if (field && (this.state.data[field] || this.state.data[field] === 0)) {
      v = this.state.data[field];
    }

    const {max, min, endingLabel, width, range} = options || {};

    return [
      <Typography
        key='field-label'
        className={cx(styles.panelDetailsCellLabel, styles.panelDetailsCell)}>{label}
      </Typography>,
      <div
        className={cx(styles.panelDetailsCellValue, styles.panelDetailsCell)}
        key='field-value'
      >
        <div className={styles.inline}>
          <NumberField
            range={range}
            style={{width}}
            value={v}
            onChange={v => {
              if (max && v > max) return;
              if ((min === 0 || min) && v < min) return;
              if (v === undefined) v = null;
              this.handlerOnChange({[field]: v});
            }}
          />
          {endingLabel && <Label>{endingLabel}</Label>}
        </div>
      </div>
    ];
  };


  onCancel = () => {
    const {onCancel} = this.props;
    if (onCancel) onCancel();
  };

  render() {
    this.tempStateData = null;

    const {id, dicts} = this.props;
    const {error, isChange, data = {}, loading} = this.state;
    const {finRequestNumber, borrowerName, borrowerINN, attachFiles, penalty, legalCosts} = data;

    const renderRows = (items) => {
      let rows = [];

      for (let i = 0; i < items.length; i += 2) {
        let left = items[i];
        let right = items[i + 1];
        const dark = !!((rows.length + 1) % 2);

        rows.push(
          <div className={cx(styles.panelDetailsRow, {[styles.panelDetailsRowDark]: dark})}>
            {left || this.renderField()}
            {right || this.renderField()}
          </div>
        )
      }

      return (
        <div className={styles.panelDetailsTable}>
          {rows}
        </div>
      );
    };

    return (
      <div className={cx('CollectionCaseEditor', styles.box)}>
        <Paper>
          <Toolbar className={styles.toolbar}>
            <Typography className={styles.title}>
              Заявка №{finRequestNumber} от {borrowerName} ИНН "{borrowerINN}"
            </Typography>
            <div>
              {error
                ?
                <Tooltip title={<div className={styles.errorTooltip}>{error}</div>}>
                  <Button
                    className={styles.save}
                    variant='contained'
                    color='secondary'
                  >
                    Сохранить
                  </Button>
                </Tooltip>
                :
                <Button
                  disabled={!isChange}
                  className={styles.save}
                  variant='contained'
                  color='primary'
                  onClick={this.onSave}
                >
                  Сохранить
                </Button>
              }
              <Button className={styles.cancel} onClick={this.onCancel}>Отмена</Button>
            </div>
          </Toolbar>
        </Paper>
        <Expansion
          defaultExpanded={true}
          label={'Общие сведения'}
        >
          {renderRows([
            this.renderFieldDict('Статус работы по взысканию', 'collectionCaseStateId', dicts.collectionCaseState),
            this.renderField('Тип займа', 'finRequestTypeName'),
            this.renderFieldDict('Краткое описание', 'creditDealStateId', dicts.creditDealState),
            this.renderField('Статус займа', 'finRequestStateName'),
            this.renderField('Дата выдачи займа', 'issueDate', dateToDate),
            this.renderField('Сумма займа', 'creditCaseSum', toMoney),
            this.renderField('Дата возврата', 'returnDate', dateToDate),
            this.renderField('Остаток по % и пени', 'percentSumRemainder', toMoney),
            this.renderField('Срок займа', 'countDay'),
            this.renderField('Всего', 'totalRefund', toMoney),
            this.renderField('Отправка денег', 'sendingMoneyTypeName'),
            this.renderField('Инвесторов физ. лиц', 'investorPhysicalPersonCount'),
            this.renderFieldBool('Спец. счет', 'specialAccountId'),
            this.renderField('Всего средств инвесторов физ. лиц', 'investorPhysicalPersonSum', toMoney),//this.renderFieldBool('Сокредитование', 'coCrediting'),
            this.renderField('Дата обновления статуса', 'lastChangeDate', dateToDate),
            this.renderField('Всего по автоуступке', 'investorPhysicalPersonCessionSum', (v) => toMoney(v || 0)),//this.renderField('Штрафы и неустойки'),
            this.renderFieldDateEdit('Дата следующего мониторинга', 'nextMonitoringDate'),
            this.renderFieldNumber('Вероятность взыскания', 'debtCollectionProbability', {max: 100, min: 0, width: '70px', endingLabel: '%', range: 2}),
            this.renderFieldDateEdit('Претензия направлена заёмщику', 'claimDirectedToBorrower', {placeholder: 'Нет', disabled: data.finRequestStateId === 3, gteCurrentDate: true, lteDate: data.issueDate}),
            this.renderFieldDateEdit('Подано заявление в суд', 'claimDirectedToCourt', {placeholder: 'Нет', disabled: data.finRequestStateId === 3, gteCurrentDate: true, lteDate: data.issueDate}),
          ])}
        </Expansion>
        <Expansion
          defaultExpanded={true}
          label={'ЭТП'}
        >
            {renderRows([
              this.renderField('Наименование ЭТП', 'etpName'),
              this.renderField('ФЗ', 'fz'),
              this.renderField(),//this.renderFieldLink('Номер ЕИС', 'eisLink', this.state.data && this.state.data.numberInEIS),//поле более не актуально
              this.renderFieldLink('Реестр БГ', 'bankGuaranteeLink', 'поиск в ЕИС'),
              this.renderFieldLink('Номер закупки', 'numberOnEtpLink', this.state.data && this.state.data.numberOnEtp),
              this.renderField('Дата ППИ', 'resultProtocolPublicationDate', dateToDate),
              this.renderField('Место', 'borrowerPlaceAtAuction'),
              this.renderField('Дата протокола отказа', 'denialProtocolPublicationDate', dateToDate),
              this.renderField('Статус заемщика'),
              this.renderField()
            ])}
        </Expansion>
        <Expansion
          defaultExpanded={true}
          label={'Контакты агента'}
        >
            {renderRows([
              this.renderField('ФИО Поручителя', 'guarantorFullName'),
              this.renderField(),
              this.renderField('Наименование Агента', 'agentName'),
              this.renderField('ИНН Агента', 'agentINN'),
              this.renderField('E-mail Агента', 'agentEmail'),
              this.renderField('Телефон Агента', 'agentPhone')
            ])}
        </Expansion>
        <Expansion
          defaultExpanded={true}
          label={'Контакты'}
        >
          {renderRows([
            this.renderField('Наименование заемщика', 'borrowerName'),
            this.renderField('ИНН заемщика', 'borrowerINN'),
            this.renderField('ФИО Основного Контакта Заемщика', 'mainBorrowerFullName'),
            this.renderField('ФИО из заявки Заемщика', 'requestBorrowerFullName'),
            this.renderField('E-mail Основного Контакта Заемщика', 'mainBorrowerEmail'),
            this.renderField('E-mail Из заявки Заемщика', 'requestBorrowerEmail'),
            this.renderField('Телефон Основного Контакта Заемщика', 'mainBorrowerTelephone'),
            this.renderField('Телефон из заявки Заемщика', 'requestBorrowerTelephone'),
            this.renderField('Часовой пояс', 'borrowerCounterpartyTimeZoneText'),
            this.renderField('Юридический адрес', 'borrowerCounterpartyLegalAddress'),
          ])}

          {/*<Contacts className={styles.contacts}  onChange={(v) => { this.handlerOnChange('additionalContacts', v)}}  items={data.additionalContacts}/>*/}
        </Expansion>
        <Expansion
          defaultExpanded={true}
          label={this.state.data['countDay'] && `Взаиморасчет за ${this.state.data['countDay']} ${getCorrect(this.state.data['countDay'], 'день', 'дня', 'дней')}` || 'Взаиморасчет'}
        >
          {renderRows([
            this.renderField('Сумма займа', 'creditCaseSum', toMoney),
            this.renderField('Начислено % и пени', 'percent', toMoney),
            this.renderField('Возвращено', 'creditCaseSumReturned', toMoney),
            this.renderField('Оплачено', 'percentSumReturned', toMoney),
            this.renderField('Ожидает возврата', 'creditCaseSumRemainder', toMoney),
            this.renderField('Просрочено', 'percentSumRemainder', toMoney),
          ])}
        </Expansion>
        <ExpansionPanelPenaltyAndLegalCost collectionCaseSum={data.creditCaseSum} value={{penalty, legalCosts}} onChange={(v) => this.handlerOnChange({penalty: v.penalty, legalCosts: v.legalCosts})} />
        <ExpansionPanelCredit collectionCaseId={id} defaultExpanded={false} onChange={(credits => {this.handlerOnChange({['credits']: credits})})} onInvestorPhysicalPersonCessionSum={v => this.handlerOnChange({['investorPhysicalPersonCessionSum']: v})}/>
        <Expansion
          defaultExpanded={false}
          label={'Прикрепленные файлы'}
        >
          {loading
          &&
          <Spinner/>
          ||
          <AttachFiles
            className={styles.attachFiles}
            files={attachFiles}
            onDelete={(fl) => {this.setState({isChange: true, data: {...data, attachFiles: attachFiles.filter(a => a.id !== fl.id)}})}}
            onChange={(fls) => {this.setState({isChange: true, data: {...data, attachFiles: fls}})}}
          />
          }
        </Expansion>
        <Expansion
          defaultExpanded={true}
          label={'Комментарии'}
        >
          <div className={styles.panelDetailsTable}>
            <div className={cx(styles.panelDetailsRow)}>
              <CollectionCaseComments collectionCaseId={id.toString()}/>
            </div>
          </div>
        </Expansion>
      </div>
    );
  }
}

CollectionCaseEditor.propTypes = {
  id: PropTypes.string,
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
};

CollectionCaseEditor.defaultProps = {};

export default CollectionCaseEditor;


// WEBPACK FOOTER //
// ./src/components/page/CollectionCaseEditor/CollectionCaseEditor.jsx